import React, { useContext, useState, createContext, useEffect } from "react";
import toast from "react-hot-toast";
import { Navigate, useNavigate } from "react-router-dom";
import useFetch from "../hooks/useAxios";
import { useAuth } from "./authContext";

const CreatePlaceContext = createContext();

const CreatePlaceProvider = ({ children }) => {
  const [isPlaceComplete, setIsPlaceCompleter] = useState(false);
  const [isEditPlaceComplete, setIsEditPlaceCompleter] = useState();

  const [ResideseId, setResidenceId] = useState();
  const [createPostData, setcreatePostData] = useState(); 
  const [createEditPostData, setcreateEditPostData] = useState();

  const [loading,setloading]=useState(false)

  const [createInfoData, setCreateInfoData] = useState({
    stepOne: {
      category: "" //['apartment', 'villa', 'ecotourism_collection', 'hotel'
    },
    stepTwo: {
      title: "",
      type: "",
      space: "",
      foundation_size: "",
      area_size: "",
      floors: "",
      description: ""
    },
    stepThree: {
      city: [{name:"",title:""}],
      village: "",
      address: "",
      postal_code: ""
    },
    stepFour: {
      lat: null,
      lng: null
    },
    stepFive: {
      capacity: 0,
      max_capacity: 0,
      rooms_count: 0,
      double_bed_count: 0,
      single_bed_count: 0,
      traditional_bed_count: 0,
      sleep_space_description: "",
      custom_sleep_items: []
    },
    stepSix: {
      environment_texture: [],
      access_path: "",

      places:  {
         welfare: [
        
         ],
         sport: [
       
         ]
      }
    },
    stepSeven: {
      parkingCount: 0,
      bathroom: 0,
      restroom: 0,
      custom_facilities: {
        welfare: [],
        sport: [],
        heating: [],
        cooling: [],
        kitchen: [],
        safety: []
      },
      facilities: {
        welfare: [],
        sport: [],
        heating: [],
        cooling: [],
        kitchen: [],
        safety: []
      }
    },
    stepEight: {
      elderly_and_minors: false,
      physical_disabilities: false,
      disinfected: false,
      long_term: false,
      have_janitor: false,
      economical: false,
      luxury: false
    },
    stepNine: {
      entrance_time: 0,
      leaving_time: 0,
      min_stay: 0,
      max_stay: 0,
      pet_check_in: false,
      smoking: false,
      single: false,
      party: false
    },
    stepTen: {
      cancel_regulation: "normal" //"strict","permissive"
    },
    stepTwelve: {
      peak_day: "",
      weekend: "",
      in_week: "",
      per_extra_person: ""
    },
    stepthirteen: {
      general_discount: [
        {
          discount_type: "short",
          percentage_amount: "",
          day_count: ""
        },
        {
          discount_type: "long",
          percentage_amount: "",
          day_count: ""
        }
      ]
    },
    stepFourteen: {
      thumbnail: null,
      media: [],
      newMedia:[]
    },

    stepSixteen: {
      document_image: null,
      owner_certificate: null,
      emergency_name: "",
      emergency_phone: "",
      ownership_type: ""
    }
  });
  //"document_type": owner, janitor, tenant, friend  ==>malekiat

  const updatePlaceDetail = (step, changeValue) => {
    setCreateInfoData(before => ({
      ...before,
      [step]: changeValue
    }));
  };

  //
  const finishPlace = () => {
    const coolingObject = {};
    const HeatingObject = {};
    const WalfareObject = {};
    const SportObject = {};
    const KitchenObject = {};
    const SafteyObject = {};
    const CustomcoolingObject = {};
    const CustomHeatingObject = {};
    const CustomWalfareObject = {};
    const CustomSportObject = {};
    const CustomKitchenObject = {};
    const CustomSafteyObject = {};

    createInfoData.stepSeven.facilities.cooling.forEach((element, index) => {
      coolingObject[element.value] = {
        count: 0,
        description: null
      };
    });
    createInfoData.stepSeven.facilities.heating.forEach((element, index) => {
      HeatingObject[element.value] = {
        count: 0,
        description: null
      };
    });
    createInfoData.stepSeven.facilities.sport.forEach((element, index) => {
      SportObject[element.value] = {
        count: 0,
        description: null
      };
    });
    createInfoData.stepSeven.facilities.kitchen.forEach((element, index) => {
      KitchenObject[element.value] = {
        count: 0,
        description: null
      };
    });
    createInfoData.stepSeven.facilities.safety.forEach((element, index) => {
      SafteyObject[element.value] = {
        count: 0,
        description: null
      };
    });
    createInfoData.stepSeven.facilities.welfare.forEach((element, index) => {
      WalfareObject[element.value] = {
        count:
          element.value === "parking"
            ? createInfoData.stepSeven.parkingCount
            : element.value === "bathroom"
              ? createInfoData.stepSeven.bathroom
              : element.value === "iranian_wc"
                ? createInfoData.stepSeven.restroom
                : 0,
        description: null
      };
    });
    const NewFacilities = {
      facilities: {
        cooling: coolingObject,
        heating: HeatingObject,
        safety: SafteyObject,
        welfare: WalfareObject,
        kitchen: KitchenObject,
        sport: SportObject
      }
    };
    createInfoData.stepSeven.custom_facilities.cooling.forEach(
      (element, index) => {
        CustomcoolingObject[element.value] = {
          count: 0,
          description: null
        };
      }
    );
    createInfoData.stepSeven.custom_facilities.heating.forEach(
      (element, index) => {
        CustomHeatingObject[element.value] = {
          count: 0,
          description: null
        };
      }
    );
    createInfoData.stepSeven.custom_facilities.sport.forEach(
      (element, index) => {
        CustomSportObject[element.value] = {
          count: 0,
          description: null
        };
      }
    );
    createInfoData.stepSeven.custom_facilities.kitchen.forEach(
      (element, index) => {
        CustomKitchenObject[element.value] = {
          count: 0,
          description: null
        };
      }
    );
    createInfoData.stepSeven.custom_facilities.safety.forEach(
      (element, index) => {
        CustomSafteyObject[element.value] = {
          count: 0,
          description: null
        };
      }
    );
    createInfoData.stepSeven.custom_facilities.welfare.forEach(
      (element, index) => {
        CustomWalfareObject[element.value] = {
          count:
            element.value === "parking"
              ? createInfoData.stepSeven.parkingCount
              : element.value === "bathroom"
                ? createInfoData.stepSeven.bathroom
                : element.value === "iranian_wc"
                  ? createInfoData.stepSeven.restroom
                  : 0,
          description: null
        };
      }
    );
    const NewCustomFacilities = {
      custom_facilities: {
        cooling: CustomcoolingObject,
        heating: CustomHeatingObject,
        safety: CustomSafteyObject,
        welfare: CustomWalfareObject,
        kitchen: CustomKitchenObject,
        sport: CustomSportObject
      }
    };
    // createInfoData.stepFourteen.media

    const newMedia = [];
    createInfoData.stepFourteen.media.forEach(i => newMedia.push(i.file));

     const newEditMedia = []
     createInfoData.stepFourteen.newMedia?.forEach(i => newEditMedia.push({
       path:i.path,
       delete:i.delete ? true : false
     }));
     console.log("newEditMedia",newEditMedia)
     console.log("Media",newMedia)

    const formData = new FormData();
    formData.append("category", createInfoData.stepOne.category);
    formData.append("title", createInfoData.stepTwo.title);
    formData.append("type", createInfoData.stepTwo.type);
    formData.append("foundation_size", createInfoData.stepTwo.foundation_size);
    formData.append("area_size", createInfoData.stepTwo.area_size);
    formData.append("floors", createInfoData.stepTwo.floors);
    formData.append("space", createInfoData.stepTwo.space);
    formData.append("description", createInfoData.stepTwo.description);
    formData.append("city", createInfoData.stepThree.city[0].name);
    formData.append("village", createInfoData.stepThree.village);
    formData.append("address", createInfoData.stepThree.address);
    formData.append("postal_code", createInfoData.stepThree.postal_code);
    formData.append("lat", createInfoData.stepFour.lat);
    formData.append("lng", createInfoData.stepFour.lng);
    formData.append("capacity", createInfoData.stepFive.capacity);
    formData.append("max_capacity", createInfoData.stepFive.max_capacity);

    formData.append("rooms_count", createInfoData.stepFive.rooms_count);
    formData.append(
      "double_bed_count",
      createInfoData.stepFive.double_bed_count
    );
    formData.append(
      "single_bed_count",
      createInfoData.stepFive.single_bed_count
    );
    formData.append(
      "traditional_bed_count",
      createInfoData.stepFive.traditional_bed_count
    );
    formData.append(
      "sleep_space_description",
      createInfoData.stepFive.sleep_space_description
    );
    formData.append(
      "custom_sleep_items",
      JSON.stringify(createInfoData.stepFive.custom_sleep_items)
    );

    formData.append(
      "environment_texture",
      JSON.stringify(createInfoData.stepSix.environment_texture)
    );
    console.log("environment_texture",createInfoData.stepSix.environment_texture)

    formData.append("access_path", createInfoData.stepSix.access_path);
    formData.append("places", JSON.stringify(createInfoData.stepSix.places));
    formData.append("facilities", JSON.stringify(NewFacilities));
    formData.append("custom_facilities", JSON.stringify(NewCustomFacilities));

    formData.append(
      "elderly_and_minors",
      createInfoData.stepEight.elderly_and_minors ? 1 : 0
    );
    formData.append(
      "physical_disabilities",
      createInfoData.stepEight.physical_disabilities ? 1 : 0
    );
    formData.append(
      "disinfected",
      createInfoData.stepEight.disinfected ? 1 : 0
    );
    formData.append("long_term", createInfoData.stepEight.long_term ? 1 : 0);
    formData.append(
      "have_janitor",
      createInfoData.stepEight.have_janitor ? 1 : 0
    );
    formData.append("economical", createInfoData.stepEight.economical ? 1 : 0);
    formData.append("luxury", createInfoData.stepEight.luxury ? 1 : 0);

    formData.append("entrance_time", createInfoData.stepNine.entrance_time);
    formData.append("leaving_time", createInfoData.stepNine.leaving_time);
    formData.append("min_stay", createInfoData.stepNine.min_stay);
    formData.append("max_stay", createInfoData.stepNine.max_stay);
    formData.append(
      "pet_check_in",
      createInfoData.stepNine.pet_check_in ? 1 : 0
    );
    formData.append("smoking", createInfoData.stepNine.smoking ? 1 : 0);
    formData.append("single", createInfoData.stepNine.single ? 1 : 0);
    formData.append("party", createInfoData.stepNine.party ? 1 : 0);

    formData.append(
      "cancel_regulation",
      createInfoData.stepTen.cancel_regulation
    );
    //per_extra_person
    formData.append("peak_day", createInfoData.stepTwelve.peak_day);
    formData.append("weekend", createInfoData.stepTwelve.weekend);
    formData.append("in_week", createInfoData.stepTwelve.in_week);
    formData.append(
      "per_extra_person",
      createInfoData.stepTwelve.per_extra_person
    );
    formData.append(
      "general_discount",
      JSON.stringify(createInfoData.stepthirteen.general_discount)
    );
    if(ResideseId){
      if(typeof createInfoData.stepFourteen.thumbnail === "object"){
        formData.append("thumbnail", createInfoData.stepFourteen.thumbnail);
      }
    }else{
      formData.append("thumbnail", createInfoData.stepFourteen.thumbnail);

    }


   // formData.append("medias", JSON.stringify(newMedia));
    if(ResideseId){
      newMedia.forEach((i,index)=>formData.append(`newMedias[${index}]`,i))
      newEditMedia.forEach((i,index)=>formData.append(`medias[${index}]`,i))


    }else{
      newMedia.forEach((i,index)=>formData.append(`medias[${index}]`,i))

    }

    formData.append(
      "ownership_type",
      createInfoData.stepSixteen.ownership_type
    );
    //ownership_type
    if(ResideseId){
      if(typeof createInfoData.stepFourteen.thumbnail === "object"){
       formData.append(
      "document_image",
      createInfoData.stepSixteen.document_image
    );
      }
    }else{
     formData.append(
      "document_image",
      createInfoData.stepSixteen.document_image
    );

    }
    if(ResideseId){
      if (createInfoData.stepSixteen.owner_certificate) {
      if(typeof createInfoData.stepFourteen.thumbnail === "object"){
        formData.append(
          "owner_certificate",
          createInfoData.stepSixteen.owner_certificate
        )

      }}
    }else{
      if (createInfoData.stepSixteen.owner_certificate) {
        formData.append(
          "owner_certificate",
          createInfoData.stepSixteen.owner_certificate
        )

      }

    
    }

   
  
    
    formData.append(
      "emergency_name",
      createInfoData.stepSixteen.emergency_name
    );
    formData.append(
      "emergency_phone",
      createInfoData.stepSixteen.emergency_phone
    );

    setcreatePostData(formData);
  }; 
  
const updatePlace = () => {
    const coolingObject = {};
    const HeatingObject = {};
    const WalfareObject = {};
    const SportObject = {};
    const KitchenObject = {};
    const SafteyObject = {};
    const CustomcoolingObject = {};
    const CustomHeatingObject = {};
    const CustomWalfareObject = {};
    const CustomSportObject = {};
    const CustomKitchenObject = {};
    const CustomSafteyObject = {};

    createInfoData.stepSeven.facilities.cooling.forEach((element, index) => {
      coolingObject[element.value] = {
        count: 0,
        description: null
      };
    });
    createInfoData.stepSeven.facilities.heating.forEach((element, index) => {
      HeatingObject[element.value] = {
        count: 0,
        description: null
      };
    });
    createInfoData.stepSeven.facilities.sport.forEach((element, index) => {
      SportObject[element.value] = {
        count: 0,
        description: null
      };
    });
    createInfoData.stepSeven.facilities.kitchen.forEach((element, index) => {
      KitchenObject[element.value] = {
        count: 0,
        description: null
      };
    });
    createInfoData.stepSeven.facilities.safety.forEach((element, index) => {
      SafteyObject[element.value] = {
        count: 0,
        description: null
      };
    });
    createInfoData.stepSeven.facilities.welfare.forEach((element, index) => {
      WalfareObject[element.value] = {
        count:
          element.value === "parking"
            ? createInfoData.stepSeven.parkingCount
            : element.value === "bathroom"
              ? createInfoData.stepSeven.bathroom
              : element.value === "iranian_wc"
                ? createInfoData.stepSeven.restroom
                : 0,
        description: null
      };
    });
    const NewFacilities = {
      facilities: {
        cooling: coolingObject,
        heating: HeatingObject,
        safety: SafteyObject,
        welfare: WalfareObject,
        kitchen: KitchenObject,
        sport: SportObject
      }
    };
    createInfoData.stepSeven.custom_facilities.cooling.forEach(
      (element, index) => {
        CustomcoolingObject[element.value] = {
          count: 0,
          description: null
        };
      }
    );
    createInfoData.stepSeven.custom_facilities.heating.forEach(
      (element, index) => {
        CustomHeatingObject[element.value] = {
          count: 0,
          description: null
        };
      }
    );
    createInfoData.stepSeven.custom_facilities.sport.forEach(
      (element, index) => {
        CustomSportObject[element.value] = {
          count: 0,
          description: null
        };
      }
    );
    createInfoData.stepSeven.custom_facilities.kitchen.forEach(
      (element, index) => {
        CustomKitchenObject[element.value] = {
          count: 0,
          description: null
        };
      }
    );
    createInfoData.stepSeven.custom_facilities.safety.forEach(
      (element, index) => {
        CustomSafteyObject[element.value] = {
          count: 0,
          description: null
        };
      }
    );
    createInfoData.stepSeven.custom_facilities.welfare.forEach(
      (element, index) => {
        CustomWalfareObject[element.value] = {
          count:
            element.value === "parking"
              ? createInfoData.stepSeven.parkingCount
              : element.value === "bathroom"
                ? createInfoData.stepSeven.bathroom
                : element.value === "iranian_wc"
                  ? createInfoData.stepSeven.restroom
                  : 0,
          description: null
        };
      }
    );
    const NewCustomFacilities = {
      custom_facilities: {
        cooling: CustomcoolingObject,
        heating: CustomHeatingObject,
        safety: CustomSafteyObject,
        welfare: CustomWalfareObject,
        kitchen: CustomKitchenObject,
        sport: CustomSportObject
      }
    };
    // createInfoData.stepFourteen.media

    const newMedia = [];
    createInfoData.stepFourteen.media.forEach(i => newMedia.push(i.file));

     const newEditMedia = []
     createInfoData.stepFourteen.newMedia?.forEach(i => newEditMedia.push({
       path:i.path,
       delete:i.delete ? true : false
     }));
   
    const formData = new FormData();
    formData.append("category", createInfoData.stepOne.category);
    formData.append("title", createInfoData.stepTwo.title);
    formData.append("type", createInfoData.stepTwo.type);
    formData.append("foundation_size", createInfoData.stepTwo.foundation_size);
    formData.append("area_size", createInfoData.stepTwo.area_size);
    formData.append("floors", createInfoData.stepTwo.floors);
    formData.append("space", createInfoData.stepTwo.space);
    formData.append("description", createInfoData.stepTwo.description);
    formData.append("city", createInfoData.stepThree.city[0].name);
    formData.append("village", createInfoData.stepThree.village);
    formData.append("address", createInfoData.stepThree.address);
    formData.append("postal_code", createInfoData.stepThree.postal_code);
    formData.append("lat", createInfoData.stepFour.lat);
    formData.append("lng", createInfoData.stepFour.lng);
    formData.append("capacity", createInfoData.stepFive.capacity);
    formData.append("max_capacity", createInfoData.stepFive.max_capacity);

    formData.append("rooms_count", createInfoData.stepFive.rooms_count);
    formData.append(
      "double_bed_count",
      createInfoData.stepFive.double_bed_count
    );
    formData.append(
      "single_bed_count",
      createInfoData.stepFive.single_bed_count
    );
    formData.append(
      "traditional_bed_count",
      createInfoData.stepFive.traditional_bed_count
    );
    formData.append(
      "sleep_space_description",
      createInfoData.stepFive.sleep_space_description
    );
    formData.append(
      "custom_sleep_items",
      JSON.stringify(createInfoData.stepFive.custom_sleep_items)
    );

    formData.append(
      "environment_texture",
      JSON.stringify(createInfoData.stepSix.environment_texture)
    );
    formData.append("access_path", createInfoData.stepSix.access_path);
    formData.append("places", JSON.stringify(createInfoData.stepSix.places));
    formData.append("facilities", JSON.stringify(NewFacilities));
    formData.append("custom_facilities", JSON.stringify(NewCustomFacilities));

    formData.append(
      "elderly_and_minors",
      createInfoData.stepEight.elderly_and_minors ? 1 : 0
    );
    formData.append(
      "physical_disabilities",
      createInfoData.stepEight.physical_disabilities ? 1 : 0
    );
    formData.append(
      "disinfected",
      createInfoData.stepEight.disinfected ? 1 : 0
    );
    formData.append("long_term", createInfoData.stepEight.long_term ? 1 : 0);
    formData.append(
      "have_janitor",
      createInfoData.stepEight.have_janitor ? 1 : 0
    );
    formData.append("economical", createInfoData.stepEight.economical ? 1 : 0);
    formData.append("luxury", createInfoData.stepEight.luxury ? 1 : 0);

    formData.append("entrance_time", createInfoData.stepNine.entrance_time);
    formData.append("leaving_time", createInfoData.stepNine.leaving_time);
    formData.append("min_stay", createInfoData.stepNine.min_stay);
    formData.append("max_stay", createInfoData.stepNine.max_stay);
    formData.append(
      "pet_check_in",
      createInfoData.stepNine.pet_check_in ? 1 : 0
    );
    formData.append("smoking", createInfoData.stepNine.smoking ? 1 : 0);
    formData.append("single", createInfoData.stepNine.single ? 1 : 0);
    formData.append("party", createInfoData.stepNine.party ? 1 : 0);
    formData.append(
      "cancel_regulation",
      createInfoData.stepTen.cancel_regulation
    );
    //per_extra_person
    formData.append("peak_day", createInfoData.stepTwelve.peak_day);
    formData.append("weekend", createInfoData.stepTwelve.weekend);
    formData.append("in_week", createInfoData.stepTwelve.in_week);
    formData.append(
      "per_extra_person",
      createInfoData.stepTwelve.per_extra_person
    );

    formData.append(
      "general_discount",
      JSON.stringify(createInfoData.stepthirteen.general_discount)
    );
    if(ResideseId){
      if(typeof createInfoData.stepFourteen.thumbnail === "object"){
        formData.append("thumbnail", createInfoData.stepFourteen.thumbnail);
      }
    }else{
      formData.append("thumbnail", createInfoData.stepFourteen.thumbnail);

    }


   // formData.append("medias", JSON.stringify(newMedia));
    if(ResideseId){
      newMedia.forEach((i,index)=>formData.append(`newMedias[${index}]`,i))
      newEditMedia.forEach((i,index)=>formData.append(`medias[${index}]`,JSON.stringify(i)))
    }else{
      newMedia.forEach((i,index)=>formData.append(`medias[${index}]`,i))
    }

    formData.append(
      "ownership_type",
      createInfoData.stepSixteen.ownership_type
    );
    //ownership_type
    if(ResideseId){
      if(typeof createInfoData.stepSixteen.document_image === "object"){
       formData.append(
      "document_image",
      createInfoData.stepSixteen.document_image
    );
      }
    }else{
     formData.append(
      "document_image",
      createInfoData.stepSixteen.document_image
    );

    }
    if(ResideseId){
      if (createInfoData.stepSixteen.owner_certificate) {
      if(typeof createInfoData.stepSixteen.owner_certificate === "object"){
        formData.append(
          "owner_certificate",
          createInfoData.stepSixteen.owner_certificate
        )

      }}
    }else{
      if (createInfoData.stepSixteen.owner_certificate) {
        formData.append(
          "owner_certificate",
          createInfoData.stepSixteen.owner_certificate
        )

      }

    
    }

   
  
    
    formData.append(
      "emergency_name",
      createInfoData.stepSixteen.emergency_name
    );
    formData.append(
      "emergency_phone",
      createInfoData.stepSixteen.emergency_phone
    );
    setcreateEditPostData(formData);
  };
  useEffect(
    () => {
      if (createPostData) {
        apiCreateResideces.reFetch();
      }
    },
    [createPostData]
  );
   useEffect(
     () => {
       if (createEditPostData) {
         apiUpdateResideces.reFetch();
       }
     },
     [createEditPostData]
   );


  const addPlaceStepTwoItem = (step, field, newValue) => {
    const before = { ...createInfoData };
    before[step][field].push(newValue);
    setCreateInfoData(before);
  };

  const deletePlaceStepTwoItem = (step, field, index) => {
    const before = { ...createInfoData };
    before[step][field].splice(index, 1);
    setCreateInfoData(before);
  };

  const editPlaceStepTwoItem = (step, field, index, newValue) => {
    const before = { ...createInfoData };
    if (before[step][field][index].pre_prop) {
      before[step][field][index].pre_prop = newValue;
    } else {
      before[step][field][index].prop = newValue;
    }

    setCreateInfoData(before);
  };

  ///api____
const navigate =useNavigate()
  const apiCreateResideces = useFetch({
    method: "post",
    url: "api/host/residences/store",
    noHeader: false,
    trigger: false,
    data: createPostData,
    gzip:true,
  
    argFunc: res => {
      setIsPlaceCompleter(true);
      setloading(false)
      toast.success("اقامتگاه شما ساخته شد .منتظر تایید ادمین باشید");
      navigate("/user")
    },
    errMessage:err=>{
      setloading(false)
      if(err.response.data.message){
        toast.error(err.response.data.message)
      }
    }
  });

  const apiUpdateResideces = useFetch({
    method: "post",
    url: `api/host/residences/update/${ResideseId}`,
    noHeader: false,
    trigger: false,
    data: createEditPostData,
    gzip:true,
    argFunc: res => {
      setIsEditPlaceCompleter(false);
      setloading(false)
      toast.success("اقامتگاه شما بروزرسانی شد .منتظر تایید ادمین باشید");
      navigate("/user")
    },
    errMessage:err=>{
      if(err.response.data.message){
        toast.error(err.response.data.message)
      }
    }
  });
  useEffect(() => {
   if(isEditPlaceComplete){
    updatePlace()
   }
  }, [isEditPlaceComplete])
  

  return (
    <CreatePlaceContext.Provider
      value={{
        createInfoData,
        updatePlaceDetail,
        addPlaceStepTwoItem,
        deletePlaceStepTwoItem,
        editPlaceStepTwoItem,
        isPlaceComplete,
        finishPlace,
        apiCreateResideces,
        loading,
        setloading,
        setResidenceId,
        setCreateInfoData,
        updatePlace,
        setIsEditPlaceCompleter,
        isEditPlaceComplete
      }}
    >
      {children}
    </CreatePlaceContext.Provider>
  );
};

const useCreatePlace = () => useContext(CreatePlaceContext);

export { useCreatePlace, CreatePlaceProvider };
